<div class="modal-header">
    <h5 class="modal-title">{{title}}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss();"></button>
</div>
<div class="modal-body">
    <div class="one" [innerHtml]="message"></div>
    <p class="mb-0 text-danger" *ngIf="subMessage">{{subMessage}}</p>
</div>
<div class="modal-footer">
    <button ngbAutofocus type="button" class="btn" *ngIf="actionBtnIsVisible" [class.btn-primary]="actionBtnType == 'PRIMARY'" [class.btn-danger]="actionBtnType == 'DANGER'" (click)="actionConfirmed();">{{actionBtnTitle}}</button>
    <button type="button" class="btn btn-secondary" (click)="actionCanceled();">{{cancelBtnTitle}}</button>
</div>
